export const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getDateRangeDays = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const days = [];
  const current = new Date(startDate);
  while (current <= endDate) {
    days.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return days;
};

export const getCurrentMonthRange = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  return {
    startDate: formatDateLocal(firstDay),
    endDate: formatDateLocal(lastDay),
  };
};

/** Start/end 'YYYY-MM-DD' bounds for the month containing `date`. */
export const getMonthRange = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  return {
    start: formatDateLocal(new Date(year, month, 1)),
    end: formatDateLocal(new Date(year, month + 1, 0)),
  };
};

/**
 * Week-aligned day grid for the month containing `date`, matching the
 * calendar page's layout: `null` placeholders pad the leading blank days of
 * the week (Sunday-start) so the array renders directly into a grid-cols-7
 * layout, followed by `{ day, date, isToday }` for each day of the month.
 */
export const getMonthGridDays = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const todayStr = formatDateLocal(new Date());
  const days = [];

  for (let i = 0; i < firstDayOfMonth.getDay(); i++) {
    days.push(null);
  }
  for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    days.push({ day, date: dateStr, isToday: todayStr === dateStr });
  }
  return days;
};
